// extracted by mini-css-extract-plugin
export default {"email":"qfZjPBxHM28raDzwRI1d"};